<div *ngIf="data$.countries as countries" style="overflow: hidden">
  <div [ngClass]="customClass" *ngIf="countries[data]">
    <img *ngIf="countries[data].img" src="{{ countries[data].img }}" width="20" height="20" />
    <span class="ml-10"
      >{{ countries[data].name.length > length ? (countries[data].name | slice: 0:length) + '...' : countries[data].name }}&nbsp;</span
    >
  </div>
  <div [ngClass]="customClass" *ngIf="!countries[data] && !nullIsEmpty">
    <img src="/assets/new-img/flags/all.svg" width="32" height="16" class="mr-10" />
    <span class="text-color text-color--gray" i18n="@@common.all_countries">All Countries</span>
  </div>
  <div [ngClass]="customClass" *ngIf="!countries[data] && nullIsEmpty">
    <span class="c-field-value__text -light-gray" i18n="@@common.empty"> Empty </span>
  </div>
</div>
